module.exports = __webpack_public_path__ + "img/8b68201.svg";